"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowConfigSchema = void 0;
const yup_1 = require("yup");
const model_schema_1 = require("../base/model.schema");
const ConfigSchema = (0, yup_1.object)({
    configID: (0, yup_1.string)().required(),
    content: (0, yup_1.string)().required(),
});
exports.FlowConfigSchema = model_schema_1.Schema.shape({
    company: (0, yup_1.string)().required(),
    configType: (0, yup_1.string)().required(),
    customerMessageRef: (0, yup_1.string)().notRequired(),
    endpointAddress: (0, yup_1.string)().required(),
    tenantFlowName: (0, yup_1.string)().required(),
    flowName: (0, yup_1.string)().required(),
    tenant: (0, yup_1.string)().required(),
    tenantConfigType: (0, yup_1.string)().required(),
    tenantCustomerMessageRef: (0, yup_1.string)().notRequired(),
    config: ConfigSchema.required(),
});
